import {addTrialPeriodReport, removeTrialPeriodReport, updateTrialPeriodReport} from './trialPeriodReportActions'
import {Constants} from './trialPeriodReportConstants'
import {TrialPeriodReport} from '../../../model/trialPeriodReport.model'

type Actions =
	| ReturnType<typeof addTrialPeriodReport>
	| ReturnType<typeof updateTrialPeriodReport>
	| ReturnType<typeof removeTrialPeriodReport>

export function trialPeriodReportsReducer(
	state: TrialPeriodReport[] = [],
	action: Actions
) {
	switch (action.type) {
		case Constants.ADD_TRIAL_PERIOD_REPORT:
			// we check if the unique tpr id is already existing, if so we do not add it twice instead we update it
			if (state.find(t => t.trial_period_report_id === action.payload.trial_period_report_id)) {
				// we want to update the existing tpr because that is likely coming from the db with more accurate information
				return state.map(((tpr: TrialPeriodReport) => {
					if (tpr.trial_period_report_id !== action.payload.trial_period_report_id) {
						// This isn't the item we care about - keep it as-is
						return tpr
					}
					return {
						...tpr,
						...action.payload
					}
				}))
			}
			return [...state, action.payload]
		case Constants.UPDATE_TRIAL_PERIOD_REPORT:

			const objectCopy = {...action.payload}
			return state.map((report) => {
				// if id does not match, return non changed item
				if (report.trial_period_report_id !== objectCopy.trial_period_report_id) {
					return report
				}
				// replace with the updated item
				return {
					...report,
					...objectCopy
				}
			})
		case Constants.REMOVE_TRIAL_PERIOD_REPORT:
			//TODO API CALL
			return state.filter((report: TrialPeriodReport) => report.trial_period_report_id !== action.payload)
		default:
			return state
	}
}

